import React from "react";
import styles from "./styles/Detail.module.css";
import logo_android from "../imgs/logo_android.png";

export default class Cloud extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      json: null,
    };
  }

  componentDidMount() {
    fetch("assets/cloud.json")
      .then((res) => res.json())
      .then((json) => this.setState({json}));
  }

  render() {
    const {json} = this.state;
    return (
      <div className={styles.bg}>
        <div className={styles.logo}>
          <img src={logo_android} className={styles.img} />
          <div className={styles.logoText}>先行版更新包</div>
          <div className={styles.logoVersion}>{json && json.version}</div>
        </div>
        <div className={styles.btns}>
          <a href={`assets/${json && json.name}.apk`}>
            <div className={styles.btn}>更新包下载</div>
          </a>
        </div>
      </div>
    );
  }
}
